type BaseSchemaProps = {
  headline: string;
  image: string;
  author: string;
  datePublished: string;
  dateModified: string;
  siteName: string;
  description?: string;
  url?: string;
};

type ArticleSchemaProps = BaseSchemaProps;

type BlogPostingSchemaProps = BaseSchemaProps & {
  description: string;
  publisher: {
    '@type': string;
    name: string;
  };
  mainEntityOfPage: string;
  keywords?: string[];
};

export type CreateArticleSchemaProps = {
  headline: string;
  image: string;
  author: string;
  datePublished: string;
  dateModified: string;
  siteName: string;
  description?: string;
  url?: string;
};

const createCommonSchemaFields = ({
  headline,
  image,
  datePublished,
  dateModified,
  description,
  url,
}: CreateArticleSchemaProps) => ({
  headline,
  image,
  datePublished,
  dateModified,
  ...(description && { description }),
  ...(url && { url }),
});

export const createArticleSchema = (props: ArticleSchemaProps) => {
  const isAuthorFromCMS = props.author !== props.siteName;

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    ...createCommonSchemaFields(props),
    author: {
      '@type': isAuthorFromCMS ? 'Person' : 'Organization',
      name: isAuthorFromCMS ? props.author : props.siteName,
    },
  };
};

export const createBlogPostingSchema = (props: BlogPostingSchemaProps) => {
  const { author, siteName, keywords } = props;

  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    ...createCommonSchemaFields(props),
    author: {
      '@type': 'Person',
      name: author,
    },
    publisher: {
      '@type': 'Organization',
      name: siteName,
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': props.url,
    },
    ...(keywords && { keywords }),
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: ['.speakable-headline', '.speakable-body'],
    },
  };
};
